import { mergeClassNames } from "@bokio/utils/classes";

import type { ReactNode } from "react";

import * as styles from "./formGroup.scss";

interface FormGroupProps {
	children: ReactNode;
	/**
	 * @deprecated add props to handle the change instead of using className
	 */
	className?: string;
	checkBoxOrRadio?: boolean;
	align?: "center";
	hidden?: boolean;
	maxWidth?: boolean;
	noMargin?: boolean;
}

export const FormGroup = ({
	children,
	className,
	checkBoxOrRadio,
	align,
	hidden,
	maxWidth,
	noMargin,
}: FormGroupProps) => (
	<div
		className={mergeClassNames(
			className,
			styles.formGroup,
			checkBoxOrRadio && styles.checkBoxOrRadio,
			align && styles[align],
			hidden && styles.hidden,
			maxWidth && styles.maxWidth,
			noMargin && styles.noMargin,
		)}
	>
		{children}
	</div>
);
